import { segmentToAbc, sheetToAbc } from '@ezchops/musicsheet';
import { abc2svg } from './abc2svg';
export function sheetToSvg(sheet, useRepeats = true, multiStaves = false) {
    const [abcs, unitNote] = sheetToAbc(sheet);
    const [svg, error] = abc2svg(abcs, sheet.segments[0].signature, unitNote, { scale: 1, singleline: true, stretchstaff: true });
    if (svg == null) {
        throw new SVGError('SVG errors', error);
    }
    return svg;
}
export function segmentToSvg(segment, useRepeats = true) {
    const [abcs, unitNote] = segmentToAbc(segment);
    const [svg, error] = abc2svg(abcs, segment.signature, unitNote, { scale: 1, singleline: false, stretchstaff: false });
    if (svg == null) {
        throw new SVGError('SVG errors', error);
    }
    return svg;
}
export class SVGError extends Error {
    errors;
    constructor(message, errors) {
        super(message);
        this.errors = errors;
    }
}
//# sourceMappingURL=sheetToSvg.js.map